















import { Component, Vue, Ref } from 'vue-property-decorator';
import CompanySettingsForm from '@/components/Unit/CompanySettingsForm.vue';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import PermissionService from '@/utils/permission-service';

@Component({
  components: { CompanySettingsForm },
})
export default class CompanySettings extends Vue {
  @Ref('companySettingsForm') private readonly form?: CompanySettingsForm;
  @UnsavedChanges<CompanySettings>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('Company.settings'),
    },
    saveAndContinue() {
      return this.form!.saveUnitSettings();
    },
  }) public dirtyForm = false;

  private PermissionService = PermissionService;
}
